module.exports = __webpack_public_path__ + "img/photo-21.a5748716.jpg";